import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-common-button',
  templateUrl: './common-button.component.html',
  styleUrls: ['./common-button.component.scss']
})
export class CommonButtonComponent {
  @Input() text: string = '';
  @Input() icon: string = '';
  @Input() color: string = '#F58634';
  @Input() variant: 'primary' | 'secondary' | 'ghost' | 'outline' = 'primary';
  @Input() disabled: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';

  @Output() onClick = new EventEmitter<void>();

  handleClick(): void {
    if (!this.disabled) {
      this.onClick.emit();
    }
  }

  get buttonClasses(): string {
    const baseClasses = 'rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed';

    if (this.variant === 'primary') {
      return `${baseClasses} bg-[var(--button-color)] text-white border border-[var(--button-color)] hover:bg-[var(--button-color)] hover:text-white hover:bg-opacity-10 active:bg-opacity-20 active:scale-[0.98]`;
    } else if (this.variant === 'ghost') {
      return `${baseClasses} bg-transparent text-black border border-transparent hover:bg-[#b9babd] hover:bg-opacity-10 active:bg-opacity-20 active:scale-[0.98]`;
    } else if (this.variant === 'outline') {
      return `${baseClasses} bg-transparent text-[var(--button-color)] border border-[var(--button-color)] hover:bg-[var(--button-color)] hover:text-white hover:bg-opacity-10 active:bg-opacity-20 active:scale-[0.98]`;
    } else if (this.variant === 'secondary') {
      return `${baseClasses} bg-[#f7f7f7] text-black border border-[#f7f7f7] hover:bg-opacity-70 active:bg-opacity-20 active:scale-[0.98]`;
    }
    return baseClasses;
  }
}

